import { render, staticRenderFns } from "./left_2.vue?vue&type=template&id=11790f9b&scoped=true&"
import script from "./left_2.vue?vue&type=script&lang=js&"
export * from "./left_2.vue?vue&type=script&lang=js&"
import style0 from "./left_2.vue?vue&type=style&index=0&id=11790f9b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11790f9b",
  null
  
)

export default component.exports